export * from './MappedTimePeriodArray';
